/**
 * Options de site pour inventaire / stocks : sites réels + armoire de garde (virtuelle).
 */

export const DUTY_SITE_PREFIX = 'duty:';

export function siteHasDutyCabinet(site) {
  if (!site) return false;
  const central = site.is_central_pharmacy === true || Number(site.is_central_pharmacy) === 1;
  const duty = site.has_duty_cabinet === true || Number(site.has_duty_cabinet) === 1;
  return central && duty;
}

export function dutySiteKey(siteId) {
  return `${DUTY_SITE_PREFIX}${siteId}`;
}

export function parseInventorySiteKey(key) {
  const raw = key == null ? '' : String(key);
  if (!raw) return { siteId: null, stockLocation: null, isDuty: false };
  if (raw.startsWith(DUTY_SITE_PREFIX)) {
    return {
      siteId: raw.slice(DUTY_SITE_PREFIX.length),
      stockLocation: 'DUTY',
      isDuty: true
    };
  }
  return { siteId: raw, stockLocation: 'MAIN', isDuty: false };
}

/**
 * Liste plate : chaque site + une entrée « Armoire de garde » juste après la centrale si activée.
 */
export function buildInventorySiteOptions(workSites = [], centralSite = null, dutyLabel = 'Armoire de garde') {
  const central =
    (centralSite && siteHasDutyCabinet(centralSite) ? centralSite : null) ||
    workSites.find((s) => siteHasDutyCabinet(s)) ||
    null;

  const options = (workSites || []).map((s) => {
    const isCentral = Boolean(centralSite && String(centralSite.id) === String(s.id)) ||
      Boolean(s.is_central_pharmacy);
    return {
      key: String(s.id),
      siteId: s.id,
      name: s.name,
      stockLocation: 'MAIN',
      isDuty: false,
      isCentral,
      site: s
    };
  });

  if (central) {
    const dutyOption = {
      key: dutySiteKey(central.id),
      siteId: central.id,
      name: dutyLabel,
      stockLocation: 'DUTY',
      isDuty: true,
      isCentral: false,
      site: central
    };
    const afterCentral = options.findIndex(
      (o) => String(o.siteId) === String(central.id) && !o.isDuty
    );
    if (afterCentral >= 0) options.splice(afterCentral + 1, 0, dutyOption);
    else options.push(dutyOption);
  }

  return options;
}

export function inventorySessionDisplayName(session, dutyLabel = 'Armoire de garde') {
  if (!session) return '—';
  if (String(session.stock_location || '').toUpperCase() === 'DUTY') return dutyLabel;
  return session.site_name || '—';
}
